import styled from "styled-components";

const Section = styled.div`
    border-bottom: 1px solid black;
    position: relative;

    &.flexblock {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        > div {
            flex: 1;
            padding: 20px 20px;
            
            @media (max-width: 1000px) {
                padding: 20px 10px;
                min-width: 300px;
            }
        }
    }

    div.flexblock {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
        gap : 40px;

        >* {
            flex: 1;
            padding: 0;
        }
        
    }

    &.padding {
        padding: 20px 20px;

        @media (max-width: 1000px) {
            padding: 20px 10px;
        }
    }
`;

export default Section;